import { formatHtml } from "@trumpf/ux.common-storybook";
import { MyMachineDetailTemplate } from "./my-machine-detail.template";
import { addI18nTranslations, renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/My Machines/Detail",
    args: {
        assetPage: false,
        noTrainings: false,
        noServiceAgreements: false,
        softwareUpdatesV1: true,
        softwareUpdatesV2: false,
        softwareUpdateType: "AllUpdatesSubscribed",
        discontinuation: false,
    },
    argTypes: {
        assetPage: {
            control: {
                type: "boolean",
            },
        },
        noTrainings: {
            control: {
                type: "boolean",
            },
        },
        noServiceAgreements: {
            control: {
                type: "boolean",
            },
        },
        softwareUpdatesV1: {
            control: {
                type: "boolean",
            },
        },
        softwareUpdatesV2: {
            control: {
                type: "boolean",
            },
        },
        softwareUpdateType: {
            control: { type: "radio" },
            options: [
                "UpdatesNotAvailable",
                "UpdatesNotSubscribed",
                "UpdatesPartiallySubscribed",
                "AllUpdatesSubscribed",
                "WaitingForInstallationOfSecurityUpdate",
                "WaitingForInstallationOfFunctionalUpdate",
                "InstallationFailedOfSecurityUpdate",
                "InstallationFailedOfFunctionalUpdate",
                "UpdatesNotAvailableButSubscribed",
            ],
            if: { arg: "softwareUpdatesV2", truthy: true },
        },
        discontinuation: {
            control: {
                type: "boolean",
            },
        },
    },
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

const namespace = "softwareUpdates";
const translations = {
    label: "Machine software",
    learnMore: "Learn more",
    subscribeButton: "Subscribe to updates",
    closeModalButton: "Close",
    subscriptionStatus: {
        UpdatesNotSubscribed: {
            label: "Updates not subscribed",
            tooltip: {
                copy:
                    "Information on machine software updates and the installation process:",
            },
        },
        UpdatesPartiallySubscribed: {
            label: "Updates partially subscribed",
            tooltip: {
                headline: "Subscribed software types",
            },
        },
        AllUpdatesSubscribed: {
            label: "Updates subscribed",
            tooltip: {
                headline: "Subscribed software types",
            },
        },
        WaitingForInstallationOfSecurityUpdate: {
            label: "Waiting for Installation",
            tooltip: {
                copy: "Waiting for Installation of security update",
            },
        },
        WaitingForInstallationOfFunctionalUpdate: {
            label: "Waiting for Installation",
            tooltip: {
                copy: "Waiting for installation of functional update",
            },
        },
        InstallationFailedOfSecurityUpdate: {
            label: "Installation has failed",
            tooltip: {
                copy: "Installation failed for security update",
            },
        },
        InstallationFailedOfFunctionalUpdate: {
            label: "Installation has failed",
            tooltip: {
                copy: "Installation failed for functional update",
            },
        },
    },
    updateTypes: {
        Security: {
            label: "Security",
            modalTooltip: {
                copy:
                    "The Installation must be started by the operator on the machine. The update duration is displayed there before installation",
            },
        },
        Functional: {
            label: "Functions & fixes",
            modalTooltip: {
                copy:
                    "The Installation must be started by the operator on the machine. The update duration is displayed there before installation.",
            },
        },
        Force: {
            label: "Automatic installation of quick updates",
            modalTooltip: {
                copy:
                    "The installation will be done automatically with the next reboot. The operator cannot prevent the update or determine the update time. There will be no backup created. The update duration is a few seconds to a maximum of a few minutes.",
            },
        },
    },
    modal: {
        headline: "Machine software updates",
        copy: {
            1: "Here you have the option to subscribe to software updates for your machine.",
            2: "If updates are available and subscribed to, they will be downloaded to your machine within the next few hours (parallel to main time) and will be ready for installation. You decide when to start the installation on the machine.",
        },
        machine: "Machine",
        formHeadline: "Select update type",
        changeSaved: "Your change was saved.",
        errorHeadline: "Something went wrong, please try again later.",
        form: {
            field: {
                privacyPolicy: {
                    label: "By activating the updates, you accept the",
                    linkLabel: "TRUMPF conditions for machine software updates",
                    validationError: "This field is required",
                },
                buttons: {
                    cancel: "Cancel",
                    submit: "Save",
                },
            },
        },
    },
};

addI18nTranslations({
    namespace,
    language: "de_DE",
    translations,
});

export const Default = (args) =>
    renderPageTemplate(() => MyMachineDetailTemplate({ ...args }));

export const SoftwareUpdatesV2 = (args) =>
    renderPageTemplate(() =>
        MyMachineDetailTemplate({
            ...args,
            softwareUpdatesV1: false,
            softwareUpdatesV2: true,
        })
    );

Default.translations = translations;
Default.namespace = namespace;
